module.exports = __webpack_public_path__ + "img/email_icon.b4c34ae5.svg";